import { useTranslation } from 'react-i18next'
import { concatIf } from '@btime/helpers'
import { useMatch } from '@reach/router'
import React from 'react'

import TabsMenu from '../../../packages/kiti/components/tabs/TabsMenu'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
const TabMenuBar = ({ screen }) => {
  const navigate = useNavigation()
  const { t } = useTranslation('processes')
  const isKanban = useMatch('/processes/kanban/:id')
  const isList = useMatch('/processes/list/:id')
  const isDashboard = useMatch('/processes/dashboard/:id')

  const hasEmbedLink = screen?.data?.configuration?.embedLink

  const handleNavigate = path => () => {
    navigate(path)
  }

  const options = [
    { label: t('processes.kanban'), active: !!isKanban, onClick: handleNavigate(`/processes/kanban/${screen?.id}`) },
    { label: t('processes.list'), active: !!isList, onClick: handleNavigate(`/processes/list/${screen?.id}`) },
    ...concatIf(hasEmbedLink, [
      {
        label: t('processes.dashboard'),
        active: !!isDashboard,
        onClick: handleNavigate(`/processes/dashboard/${screen?.id}`)
      }
    ])
  ]

  return <TabsMenu justify="flex-start" options={options} />
}
export default TabMenuBar
